import { useToolSpecContext } from "providers/ToolSpecProvider/ToolSpecProvider";
import { DataTableStoreState } from "../store/DataTableProvider.types";
import { EuiText, EuiIcon, EuiButtonEmpty } from "@inscopix/ideas-eui";
import { ButtonToolDocs } from "components/ButtonToolDocs/ButtonToolDocs";

interface DataTableToolInfoProps {
  selectedTable: DataTableStoreState["tables"][number];
}

export const DataTableToolInfo = ({
  selectedTable,
}: DataTableToolInfoProps) => {
  // find tool spec from selected table tool version
  const { availableToolSpecs } = useToolSpecContext();
  const toolSpec =
    selectedTable?.kind === "analysis"
      ? availableToolSpecs.find(
          (toolSpec) =>
            toolSpec.toolVersionId === selectedTable?.toolVersion?.id,
        )
      : undefined;

  if (toolSpec === undefined) {
    return null;
  }

  return (
    <EuiText data-test-subj="workflow-info" color="subdued" size="s">
      <EuiIcon type="indexMapping" />
      &nbsp; <strong>{toolSpec.toolName} </strong>({toolSpec.toolVersionVersion}
      ) &nbsp;&nbsp;
      <ButtonToolDocs
        data-test-subj="tool-docs-button"
        tool={{
          key: toolSpec.spec.key,
        }}
        EuiButtonComponent={EuiButtonEmpty}
      />
    </EuiText>
  );
};
